document.addEventListener("DOMContentLoaded", () => {
  const mobileBreakpoint = 576;

  const isMobile = () => window.innerWidth <= mobileBreakpoint;

  const driftOptions = (image) => ({
    paneContainer: image.nextElementSibling,
    zoomFactor: 1.5,
    inlinePane: false,
    handleTouch: false,
  });

  let driftInstances = [];
  let productThumbnails;
  let productGallery;

  const initGalleryZoom = () => {
    if (typeof driftInstances !== "undefined") {
      driftInstances.forEach((instance) => instance.destroy());
      driftInstances = [];
    }

    if (!isMobile()) {
      document
        .querySelectorAll(".gallery-image__zoom")
        .forEach(function (image) {
          const driftInstance = new Drift(image, driftOptions(image));
          driftInstances.push(driftInstance);
        });
    }
  };

  const initSwipers = () => {
    if (typeof productThumbnails !== "undefined") productThumbnails.destroy();
    if (typeof productGallery !== "undefined") productGallery.destroy();

    productThumbnails = new Swiper("#sp-product-thumbnails", {
      direction: window.innerWidth > 576 ? "vertical" : "horizontal",
      slidesPerView: 4,
      slideToClickedSlide: true,
      spaceBetween: 12,
      loopedSlides: 50,
      navigation: {
        nextEl: ".product-thumbnails__prev",
        prevEl: ".product-thumbnails__next",
      },
      on: {
        init: function () {
          const totalSlides = this.slides.length;
          const prevArrow = document.querySelector(".product-thumbnails__prev");
          const nextArrow = document.querySelector(".product-thumbnails__next");
          if (totalSlides <= 4) {
            prevArrow.classList.add("hide");
            nextArrow.classList.add("hide");
          } else {
            prevArrow.classList.remove("hide");
            nextArrow.classList.remove("hide");
          }

          this.slides.forEach((slide) => {
            slide.addEventListener("click", () => {
              this.slideNext();
            });
          });
        },
      },
    });

    productGallery = new Swiper("#sp-product-gallery", {
      slidesPerView: 1,
      loop: true,
      loopedSlides: 50,
      allowTouchMove: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      breakpoints: {
        576: {
          allowTouchMove: false,
        },
      },
      thumbs: {
        swiper: productThumbnails,
      },
    });
  };

  const initAll = () => {
    initGalleryZoom();
    initSwipers();
  };

  const updateSwiperDirection = () => {
    const newDirection = window.innerWidth > 576 ? "vertical" : "horizontal";
    if (
      productThumbnails &&
      productThumbnails.params.direction !== newDirection
    ) {
      productThumbnails.changeDirection(newDirection);
    }
  };

  initAll();
  window.addEventListener("resize", () => {
    updateSwiperDirection();
    initGalleryZoom();
  });

  document.addEventListener("shopify:section:load", () => {
    initAll();
  });

  document.addEventListener("shopify:section:reorder", () => {
    initAll();
  });
});
